import { render, staticRenderFns } from "./TheNotification.vue?vue&type=template&id=21498ba2&scoped=true&"
import script from "./TheNotification.vue?vue&type=script&lang=js&"
export * from "./TheNotification.vue?vue&type=script&lang=js&"
import style0 from "./TheNotification.vue?vue&type=style&index=0&id=21498ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21498ba2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
